exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\r\n/*created by AHMED HAYEL*/\r\n\r\ntable tbody{\r\nbackground-color: white;\r\n}\r\ntable thead{\r\nbackground-color: #e9423e;\r\ncolor:white;\r\n}\r\n\r\nth {\r\n    text-align: center;\r\n}\r\n\r\n.sidebar {\r\n    display: none !important;\r\n}\r\n.main-panel {\r\n    width: 100% !important;\r\n}\r\n.ecriture{\r\n    font-size: 12px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/admin-component/archive/archive.component.css
// module id = 312
// module chunks = 1